import React, {useEffect, useState} from 'react';
import 'datatables.net';
import 'datatables.net-responsive';
import {GET_COLLECTION_AGGREGATE_DATA} from '../../api';
import $ from "jquery";
import {capitalize} from "../../utils/capitalize";
import cogoToast from "cogo-toast";
import moment from "moment/moment";
import {useSelector} from "react-redux";
import {message} from "../../api/app";

let searchableFields = [
    { field: 'text', isNumeric: false },
    { field: 'name', isNumeric: false }
]

const Survey = () => {

    document.title = "Survey";

    const token = localStorage.getItem('jwtToken');

    const [stateReady, setStateReady] = useState(false);
    const {province, constituencies, wards, polling_stations} = useSelector(state => state.app?.administrative);

    useEffect(() => {
        let table = $('#message_table').DataTable({
            responsive: true,
            language: {
                searchPlaceholder: 'Search name',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Message Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function (data, callback) {
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "Survey",
                        searchableFields,
                        filter: {},
                        pageSize: data.start,
                        populate: [
                            {
                                path: "user",
                                model: "user"
                            }
                        ],
                        format: 'json',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];
                        res.data.map((data) => {
                            array.push({raw: data})
                        });
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return capitalize(data.type);
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return capitalize(data.user.name)
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return moment(data.createdAt).format("Do MMM, YYYY")
                    },
                    "targets": 3
                },
                {
                    "render": function () {
                        return "No Action"
                        return `<nav class="nav nav-icon-only"><a href="#" class="nav-link edit_company"><i class="fa fa-trash"></i> Delete</a></nav>`
                    },
                    "targets": 4
                }
            ]
        });

        $('#message_table tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            return (
                '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                '<tr>' +
                '<td>Message:</td>' +
                '<td>' +
                d?.raw.text +
                '</table>'
            );
        }

        return () => {
            table.destroy();
        }

    }, []);

    const initialize = () => {
        $('#province').select2({
            placeholder: 'Select Provinces',
            multiple: true,
            width: '100%',
            data: province.map(p => ({ id: p._id, text: capitalize(p.name) }))
        });

        $('#constituency, #ward, #polling_station').select2({
            placeholder: 'Select...',
            multiple: true,
            width: '100%'
        });

        // Province → Constituency
        $('#province').on('change', function () {
            const selectedProvinces = $(this).val() || [];
            const filteredConstituencies = constituencies.filter(c =>
                selectedProvinces.includes(c.administrative)
            );

            $('#constituency').empty().select2({
                placeholder: 'Select Constituencies',
                multiple: true,
                width: '100%',
                data: filteredConstituencies.map(c => ({
                    id: c._id,
                    text: capitalize(c.name)
                }))
            }).val(null).trigger('change');

            $('#ward, #polling_station').val(null).trigger('change').empty();
        });

        // Constituency → Ward
        $('#constituency').on('change', function () {
            const selectedConstituencies = $(this).val() || [];
            const filteredWards = wards.filter(w =>
                selectedConstituencies.includes(w.constituency)
            );

            $('#ward').empty().select2({
                placeholder: 'Select Wards',
                multiple: true,
                width: '100%',
                data: filteredWards.map(w => ({
                    id: w._id,
                    text: capitalize(w.name)
                }))
            }).val(null).trigger('change');

            $('#polling_station').val(null).trigger('change').empty();
        });

        $('#ward').on('change', function () {
            const selectedWards = $(this).val() || [];
            const filteredPollings = polling_stations.filter(p =>
                selectedWards.includes(p.ward)
            );

            $('#polling_station').empty().select2({
                placeholder: 'Select Polling Stations',
                multiple: true,
                width: '100%',
                data: filteredPollings.map(p => ({
                    id: p._id,
                    text: capitalize(p.name)
                }))
            }).val(null).trigger('change');
        });
    }

    const handleShowModal = () => {
        $('#message_bulk_form').parsley();
        initialize();
        $("#modalBulkMessage").modal("show");
    }

    const handleQuickMsgShowModal = () => {
        $('#message_quick_form').parsley();
        $("#modalQuickMessage").modal("show");
    }

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    }

    const handleBulkSMSSubmit = (e) => {
        e.preventDefault();
        let sender_id = $('#sender-id').val() || $("#sender-id-1").val();
        let subject = $('#subject').val() || $("#subject-1").val();
        let text_message = $('#message').val() || $("#message-1").val();
        let provincial = $('#province').val();
        let constituency = $('#constituency').val();
        let ward = $('#ward').val();

        setStateReady(true);

        let data = {
            sender_id,
            subject,
            type: "bulk",
            message: text_message,
            admin_level: []
        };

        if(provincial.length > 0) {
            data.admin_level.push({
                model: "administrative",
                data: provincial
            });
        }

        if(constituency.length > 0) {
            data.admin_level.push({
                model: "constituency",
                data: constituency
            });
        }

        if(ward.length > 0) {
            data.admin_level.push({
                model: "ward",
                data: ward
            });
        }

        message(data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success("Message successfully created.", {position: "top-right", hideAfter: 5});
                resetForm("modalBulkMessage", "message_bulk_form");
                reloadTable();
            }
        });
    }

    const handleQuickMessageSubmit = (e) => {
        e.preventDefault();
        let sender_id = $('#sender-id').val() || $("#sender-id-1").val();
        let subject = $('#subject').val() || $("#subject-1").val();
        let text_message = $('#message').val() || $("#message-1").val();
        let mobile_number = $('#mobile-number').val();

        setStateReady(true);

        let data = {
            sender_id,
            subject,
            type: "quick",
            message: text_message,
            mobile_number
        };

        message(data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success("Message successfully created.", {position: "top-right", hideAfter: 5});
                resetForm("modalQuickMessage", "message_quick_form");
                reloadTable();
            }
        });
    }

    const reloadTable = () => {
        $('#message_table').DataTable().ajax.reload(null, false);
    };

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item active" aria-current="page">Survey</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Survey</h4>
                    </div>
                </div>

                <div className="row row-sm">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Message</h6>
                                <div className="d-flex tx-18">
                                    <a href="javascript:void(0)" className="link-03 lh-0 mg-l-10" onClick={() => reloadTable()}><i className="icon ion-md-refresh"></i></a>
                                </div>
                            </div>
                            <div className="card-body table-responsive">
                                <table id="message_table" className="table" style={{width: "100%"}}>
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th className="wd-25p">Type</th>
                                        <th className="wd-25p">User</th>
                                        <th className="wd-25p">Date</th>
                                        <th className="wd-25p">Actions</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Survey;
